import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const Home = () => import('@/views/Home')
const Complaints = () => import('@/views/Complaints')

const AdminComplaints = () => import('@/views/Complaints/admin')
const About = () => import('@/views/About')
const Login = () => import('@/views/Login')

const ComplaintDetail = () => import('@/views/Complaints/detail.vue')

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      meta: {
        title: 'Home',
        keepAlive: false
      },
      component: Home
    },
    {
      path: '/complanints/list',
      name: 'complanints',
      meta: {
        title: 'Complaints and suggestions',
        keepAlive: false 
      },
      component: Complaints
    },
    {
      path: '/complanints/admin',
      name: 'adminComplaints',
      meta: {
        title: 'Complaints and suggestions',
        keepAlive: false 
      },
      component: AdminComplaints
    },
    {
      path: '/complanints/detail',
      name: 'complaintDetail',
      meta: {
        title: 'Suggestions Detail',
        keepAlive: false
      },
      component: ComplaintDetail
    },
    {
      path: '/about',
      name: 'about',
      meta: {
        title: 'About Us',
        keepAlive: false
      },
      component: About
    },
    {
      path: '/login',
      name: 'login',
      meta: {
        title: 'Login',
        keepAlive: false
      },
      component: Login
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js